package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_chart.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.dashboard.PaymentType
import org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics.ShopStatistic
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CalendarBox
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_reports.component.DashboardReportInfo
import org.jetbrains.compose.web.css.px

@Composable
fun DashboardGeneralInfo(
    windowSizeMode: WindowSizeModeEnum,
    currencyType: String,
    dashboardItemName:String,
    dashboardItem: ShopStatistic?,
    cashRegistersCount: Int?,
    selectedDate: MonthModel,
    setCalendarStatus: (Boolean) -> Unit,
    onBackClick:()->Unit,
)
{
    val cashTotal = dashboardItem?.statData?.operations?.filter {
        it.type.toString() == PaymentType.CASH.code
    }?.sumOf { it.total ?: 0.0 } ?: 0.0

    val eftTotal = dashboardItem?.statData?.operations?.filter {
        it.type.toString() == PaymentType.EFT.code
    }?.sumOf { it.total ?: 0.0 } ?: 0.0

    val creditTotal = dashboardItem?.statData?.operations?.filter {
        it.type.toString() in  PaymentType.ALL_CREDIT_TYPES
    }?.sumOf { it.total ?: 0.0 } ?: 0.0

    val tipsTotal = dashboardItem?.statData?.operations?.filter {
        it.type.toString() == PaymentType.TIPS.code
    }?.sumOf { it.total ?: 0.0 } ?: 0.0

    val cancelledTotal = dashboardItem?.statData?.operations?.filter {
        it.type.toString() == PaymentType.REMOVED.code
    }?.sumOf { it.total ?: 0.0 } ?: 0.0

    val operationsCount = dashboardItem?.statData?.operations?.size ?: 1
    val totalRevenue = 0.0//dashboardItem?.statData?.?: 0.0
    val revenuePerOperation = if (operationsCount > 0) totalRevenue / operationsCount else 0.0


    Column(
        modifier = Modifier.fillMaxWidth()
    )
    {
        when(windowSizeMode)
        {

            WindowSizeModeEnum.Desktop ->{
                GeneralInfoWindowsMode(
                    cashTotal=cashTotal,
                    eftTotal=eftTotal,
                    creditTotal=creditTotal,
                    tipsTotal=tipsTotal,
                    cancelledTotal=cancelledTotal,
                    revenuePerOperation=revenuePerOperation,
                    dashboardItemName=dashboardItemName,
                    selectedDate=selectedDate,
                    currencyType=currencyType,
                    onBackClick={
                        onBackClick()
                    },
                    setCalendarStatus={
                        setCalendarStatus(it)
                    },
                )
            }

            WindowSizeModeEnum.TABLET->{
                GeneralInfoTabletMode(
                    cashTotal=cashTotal,
                    eftTotal=eftTotal,
                    creditTotal=creditTotal,
                    tipsTotal=tipsTotal,
                    cancelledTotal=cancelledTotal,
                    revenuePerOperation=revenuePerOperation,
                    dashboardItemName=dashboardItemName,
                    selectedDate=selectedDate,
                    currencyType=currencyType,
                    onBackClick={
                        onBackClick()
                    },
                    setCalendarStatus={
                        setCalendarStatus(it)
                    },
                )
            }

            WindowSizeModeEnum.PHONE->{
                GeneralInfoMobileMode(
                    cashTotal=cashTotal,
                    eftTotal=eftTotal,
                    creditTotal=creditTotal,
                    tipsTotal=tipsTotal,
                    cancelledTotal=cancelledTotal,
                    revenuePerOperation=revenuePerOperation,
                    dashboardItemName=dashboardItemName,
                    selectedDate=selectedDate,
                    currencyType=currencyType,
                    onBackClick={
                        onBackClick()
                    },
                    setCalendarStatus={
                        setCalendarStatus(it)
                    },
                )
            }
        }


    }


}

@Composable
private fun GeneralInfoWindowsMode(
    dashboardItemName: String,
    onBackClick: () -> Unit,
    selectedDate: MonthModel,
    setCalendarStatus: (Boolean) -> Unit,
    currencyType: String,
    cashTotal: Double,
    eftTotal: Double,
    creditTotal: Double,
    tipsTotal: Double,
    cancelledTotal: Double,
    revenuePerOperation: Double
) {


    Row(
        modifier = Modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
    )
    {
        Column()
        {
            TopDashboardChartToolbar(
                name = dashboardItemName,
                onBackClick = {
                    onBackClick()
                },
            )
            CalendarBox(
                modifier = Modifier,
                fillMaxWidth =false,
                selectedDate =selectedDate,
                label = Strings.current().date,
                width = Dimen.semiLargeEditTextWidth ,
                onClick = {
                    setCalendarStatus(true)
                }
            )

        }
        Spacer()

        Row()
        {
            if (cashTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(leftRight = Dimen.smallPadding),
                    title = Strings.current().cash,
                    value ="${formatToTwoDecimals(value=cashTotal)} $currencyType",
                    color = Theme.SuccessLight.hex,
                    icon = Res.PathIcon.cash,
                    hasBorder = true
                )
            }

            if (eftTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(leftRight = Dimen.smallPadding),
                    title = Strings.current().eft,
                    value =   "${formatToTwoDecimals(value=eftTotal,)} $currencyType" ,
                    color = Theme.PrimaryLight.hex,
                    icon = Res.PathIcon.eft,
                    hasBorder = true
                )

            }

            if (creditTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(leftRight = Dimen.smallPadding),
                    title = Strings.current().credit,
                    value ="${formatToTwoDecimals(value=creditTotal)} $currencyType",
                    color = Theme.WarningLight.hex,
                    icon = Res.PathIcon.credit,
                    hasBorder = true
                )

            }

            if (tipsTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(leftRight = Dimen.smallPadding),
                    title = Strings.current().cashRegisters,
                    value = "${formatToTwoDecimals(value=tipsTotal)} $currencyType",
                    color = Theme.SecondaryLight.hex,
                    icon = Res.PathIcon.tips,
                    hasBorder = true
                )

            }

            if (cancelledTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(leftRight = Dimen.smallPadding),
                    title = Strings.current().cancelled,
                    value = "${formatToTwoDecimals(value=cancelledTotal)} $currencyType",
                    color = Theme.ErrorLight.hex,
                    icon = Res.PathIcon.cancel,
                    hasBorder = true
                )
            }

            if (revenuePerOperation!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(leftRight = Dimen.smallPadding),
                    title = Strings.current().revenueGuest,
                    value = "${formatToTwoDecimals(value=revenuePerOperation)} $currencyType",
                    color = Theme.PrimaryInfoLight.hex,
                    icon = Res.PathIcon.revenueGuest,
                    hasBorder = true
                )
            }


        }


    }
}

@Composable
private fun GeneralInfoTabletMode(
    dashboardItemName: String,
    selectedDate: MonthModel,
    currencyType: String,
    setCalendarStatus: (Boolean) -> Unit,
    onBackClick: () -> Unit,
    cashTotal: Double,
    eftTotal: Double,
    creditTotal: Double,
    tipsTotal: Double,
    cancelledTotal: Double,
    revenuePerOperation: Double,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
    )
    {
        Row(
            modifier = Modifier
                .fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        )
        {
            TopDashboardChartToolbar(
                name = dashboardItemName,
                onBackClick = {
                    onBackClick()
                },
            )

            Spacer()

            CalendarBox(
                modifier = Modifier.margin(
                    left = Dimen.mediumPadding  ,
                    top =  0.px ,
                ),
                fillMaxWidth =false,
                selectedDate =selectedDate,
                label = Strings.current().date,
                width =Dimen.dashboardReportItemTabletPhoneWidth,
                onClick = {
                    setCalendarStatus(true)
                }
            )

        }

        Row(
            modifier = Modifier
                .margin(top = Dimen.normalPadding)
                .fillMaxWidth()
                .overflow(Overflow.Auto)
        ) {
            if (cashTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier,
                    marginTop = 0.px,
                    title = Strings.current().cash,
                    value ="${formatToTwoDecimals(value=cashTotal)} $currencyType",
                    color = Theme.SuccessLight.hex,
                    icon = Res.PathIcon.cash,
                    hasBorder = true
                )

            }

            if (eftTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(left = Dimen.normalPadding),
                    title = Strings.current().eft,
                    value = "${formatToTwoDecimals(value=eftTotal)} $currencyType" ,
                    color = Theme.PrimaryLight.hex,
                    icon = Res.PathIcon.eft,
                    hasBorder = true
                )
            }


            if (creditTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(left = Dimen.normalPadding),
                    title = Strings.current().credit,
                    value = "${formatToTwoDecimals(value=creditTotal)} $currencyType",
                    color = Theme.WarningLight.hex,
                    icon = Res.PathIcon.credit,
                    hasBorder = true
                )
            }


            if (tipsTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(left = Dimen.normalPadding),
                    title = Strings.current().tips,
                    value = "${formatToTwoDecimals(value=tipsTotal)} $currencyType",
                    color = Theme.SecondaryLight.hex,
                    icon = Res.PathIcon.tips,
                    hasBorder = true
                )
            }

            if (cancelledTotal!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(left = Dimen.normalPadding),
                    title = Strings.current().cancelled,
                    value =  "${formatToTwoDecimals(value=cancelledTotal)} $currencyType",
                    color = Theme.ErrorLight.hex,
                    icon = Res.PathIcon.cancel,
                    hasBorder = true
                )

            }

            if (revenuePerOperation!=0.0){
                DashboardReportInfo(
                    modifier = Modifier
                        .margin(left = Dimen.normalPadding),
                    title = Strings.current().revenueGuest,
                    value = "${formatToTwoDecimals(value=revenuePerOperation,)} $currencyType",
                    color = Theme.PrimaryInfoLight.hex,
                    icon = Res.PathIcon.revenueGuest,
                    hasBorder = true
                )
            }

        }
    }

}


@Composable
private fun GeneralInfoMobileMode(
    dashboardItemName: String,
    selectedDate: MonthModel,
    currencyType: String,
    setCalendarStatus: (Boolean) -> Unit,
    onBackClick: () -> Unit,
    cashTotal: Double,
    eftTotal: Double,
    creditTotal: Double,
    tipsTotal: Double,
    cancelledTotal: Double,
    revenuePerOperation: Double,
) {
    val toolbarWidth = Dimen.chartWidth.px
    val maxItemsPerRow = 2

    val visibleReports = mutableListOf<ReportItem>()

    Row(
        modifier = Modifier
            .margin(top = Dimen.normalPadding)
            .fillMaxWidth()
            .overflow(Overflow.Auto)
    )
    {
        if (cashTotal != 0.0) {
            visibleReports.add(ReportItem(
                title = Strings.current().cash,
                value = "${formatToTwoDecimals(value=cashTotal)} $currencyType",
                color = Theme.SuccessLight.hex,
                icon = Res.PathIcon.cash
            ))
        }

        if (eftTotal != 0.0) {
            visibleReports.add(ReportItem(
                title = Strings.current().eft,
                value = "${formatToTwoDecimals(value=eftTotal)} $currencyType",
                color = Theme.PrimaryLight.hex,
                icon = Res.PathIcon.eft
            ))
        }

        if (creditTotal != 0.0) {
            visibleReports.add(ReportItem(
                title = Strings.current().credit,
                value = "${formatToTwoDecimals(value=creditTotal)} $currencyType",
                color = Theme.WarningLight.hex,
                icon = Res.PathIcon.credit
            ))
        }

        if (tipsTotal != 0.0) {
            visibleReports.add(ReportItem(
                title = Strings.current().tips,
                value = "${formatToTwoDecimals(value=tipsTotal)} $currencyType",
                color = Theme.SecondaryLight.hex,
                icon = Res.PathIcon.tips
            ))
        }

        if (cancelledTotal != 0.0) {
            visibleReports.add(ReportItem(
                title = Strings.current().cancelled,
                value = "${formatToTwoDecimals(value=cancelledTotal)} $currencyType",
                color = Theme.ErrorLight.hex,
                icon = Res.PathIcon.cancel
            ))
        }

        if (revenuePerOperation != 0.0) {
            visibleReports.add(ReportItem(
                title = Strings.current().revenueGuest,
                value = "${formatToTwoDecimals(value=revenuePerOperation)} $currencyType",
                color = Theme.PrimaryInfoLight.hex,
                icon = Res.PathIcon.revenueGuest
            ))
        }
    }


    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            TopDashboardChartToolbar(
                name = dashboardItemName,
                onBackClick = {
                    onBackClick()
                },
            )

            CalendarBox(
                modifier = Modifier.margin(
                    top = Dimen.mediumPadding,
                ),
                fillMaxWidth = true,
                selectedDate = selectedDate,
                label = Strings.current().date,
                onClick = {
                    setCalendarStatus(true)
                }
            )
        }

        // Calculate how many rows we need
        val rowCount = (visibleReports.size + maxItemsPerRow - 1) / maxItemsPerRow

        // Render each row
        for (rowIndex in 0 until rowCount) {
            val startIndex = rowIndex * maxItemsPerRow
            val endIndex = minOf(startIndex + maxItemsPerRow, visibleReports.size)
            val itemsInCurrentRow = endIndex - startIndex

            Row(
                modifier = Modifier
                    .margin(top = Dimen.normalPadding)
                    .width(toolbarWidth),
                horizontalArrangement = when (itemsInCurrentRow) {
                    1 -> Arrangement.Center
                    2 -> Arrangement.SpaceAround
                    else -> Arrangement.SpaceBetween
                }
            ) {
                // Render items for this row
                for (i in startIndex until endIndex) {
                    val item = visibleReports[i]
                    DashboardReportInfo(
                        modifier = Modifier,
                        title = item.title,
                        value = item.value,
                        color = item.color,
                        icon = item.icon,
                        hasBorder = true
                    )
                }
            }
        }
    }
}

private data class ReportItem(
    val title: String,
    val value: String,
    val color: String,
    val icon: String
)